import { createUserManager } from 'redux-oidc';

const authority = process.env.REACT_APP_LOGIN_AUTHORITY;
const userManagerConfig = {
  authority,
  client_id: "nativespecies.spa",
  response_type: "code",
  scope: "openid profile nativespecies.api api1",
  redirect_uri: process.env.REACT_APP_LOGIN_REDIRECT,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOUT_REDIRECT,
  automaticSilentRenew: false
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
